import { Control, UseFormRegisterReturn } from 'react-hook-form'
import { DetailInfo, Question } from '../../interfaces/interface'

import NumberRating from '../Rating/NumberRating'
import RadioInputWithHookForm from '../RadioInputSurv/RadioInputWithHookForm'
import React from 'react'
import TextareaInputWithHookForm from '../TextField/TextareaInputWithHookForm'
import { useStyles } from './useStyles'

interface Option {
  id: string
  label: string
}

interface InputFactoryProps {
  type: 'rating' | 'radio' | 'textarea'
  control: Control<any>
  registerResponse: UseFormRegisterReturn<string>
  question: Question
  clarification?: string
  options?: Option[]
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  detailInfo?: DetailInfo
  appColor: string
}

const InputFactory: React.FC<InputFactoryProps> = ({
  type,
  control,
  registerResponse,
  question,
  clarification,
  options = [],
  detailInfo,
  onChange,
  appColor,
  ...rest
}) => {
  const classes = useStyles()

  const inputMap = {
    rating: (
      <div>
        <NumberRating
          control={control}
          fieldName={registerResponse.name}
          appColor={appColor}
          {...rest}
        />
      </div>
    ),
    radio: (
      <div>
        <RadioInputWithHookForm
          control={control}
          fieldName={registerResponse.name}
          options={options}
          detailInfo={detailInfo}
          appColor={appColor}
          {...rest}
        />
      </div>
    ),
    textarea: (
      <div>
        <TextareaInputWithHookForm
          control={control}
          fieldName={registerResponse.name}
          text={question?.question}
          maxLength={question?.maxLength}
          {...rest}
        />
      </div>
    ),
  }

  return (
    <div className={classes.contentInput}>
      <label className={classes.label}>
        {question?.question}
      </label>
      {inputMap[type]}
      {clarification && (
        <p className={classes.clarification}>
          {clarification}
        </p>
      )}
    </div>
  )
}

export default InputFactory
